var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: _vm.title,
      visible: _vm.dialogVisible,
      width: "35%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      "status-icon": "",
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "推送文字",
      prop: "pushText"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: _vm.disabled,
      type: "textarea",
      rows: "4",
      autocomplete: "off",
      placeholder: "请输入推送文字"
    },
    model: {
      value: _vm.form.pushText,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "pushText", $$v);
      },
      expression: "form.pushText"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "附图"
    }
  }, [_c("el-upload", {
    attrs: {
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      headers: _vm.uploadHeaders,
      "file-list": _vm.fileList,
      action: _vm.uploadUrl + "admin/v1/file/uploadFileImg",
      "list-type": "picture-card",
      "on-remove": _vm.handleRemove
    }
  }, [_c("i", {
    staticClass: "el-icon-plus"
  })])], 1)], 1), _c("div", {
    staticClass: "bottomDiv"
  }, [_c("el-button", {
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("关闭")]), _c("el-button", {
    attrs: {
      disabled: _vm.disabled,
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };